<template>
  <base-nav
    v-model="showMenu"
    class="navbar-absolute top-navbar"
    type="white"
    :transparent="true"
  >
    <div slot="brand" class="navbar-wrapper">
      <div class="navbar-minimize d-inline">
        <sidebar-toggle-button />
      </div>
      <div
        class="navbar-toggle d-inline"
        :class="{ toggled: $sidebar.showSidebar }"
      >
        <button type="button" class="navbar-toggler" @click="toggleSidebar">
          <span class="navbar-toggler-bar bar1"></span>
          <span class="navbar-toggler-bar bar2"></span>
          <span class="navbar-toggler-bar bar3"></span>
        </button>
      </div>
      <a class="navbar-brand" href="#pablo">{{ routeName }}</a>
    </div>

    <ul class="navbar-nav" :class="$rtl.isRTL ? 'mr-auto' : 'ml-auto'">
      <!-- <div class="search-bar input-group" @click="searchModalVisible = true"> -->
      <!--
          <input type="text" class="form-control" placeholder="Search...">
          <div class="input-group-addon"><i class="tim-icons icon-zoom-split"></i></div>
      -->
      <!-- <button
          class="btn btn-link"
          id="search-button"
          data-toggle="modal"
          data-target="#searchModal"
        >
          <i class="tim-icons icon-zoom-split"></i>
      </button>-->
      <!-- You can choose types of search input -->
      <!-- </div> -->
      <!-- <modal
        :show.sync="searchModalVisible"
        class="modal-search"
        id="searchModal"
        :centered="false"
        :show-close="true"
      >
        <input
          slot="header"
          v-model="searchQuery"
          type="text"
          class="form-control"
          id="inlineFormInputGroup"
          placeholder="SEARCH"
        />
      </modal>-->
      <div class="avatar-name">
        <p>{{ empName }}</p>
      </div>
      <base-dropdown
        tag="li"
        :menu-on-right="!$rtl.isRTL"
        title-tag="a"
        class="nav-item"
        title-classes="nav-link"
        menu-classes="dropdown-navbar"
      >
        <template slot="title">
          <div></div>
          <div class="photo">
            <img src="img/default-avatar.png" />
          </div>
          <b class="caret d-none d-lg-block d-xl-block"></b>
          <p class="d-lg-none">Log out</p>
        </template>
        <li class="nav-link">
          <router-link to="/Settings">
            <a class="nav-item dropdown-item">Settings</a>
          </router-link>
        </li>
        <hr />
        <li class="nav-link">
          <a class="nav-item dropdown-item" @click="logout()">Log out</a>
        </li>
      </base-dropdown>
    </ul>
  </base-nav>
</template>
<script>
import { CollapseTransition } from "vue2-transitions";
import { BaseNav, Modal } from "@/components";
import SidebarToggleButton from "./SidebarToggleButton";
import swal from "sweetalert2";
import util from "../../util/util";

export default {
  components: {
    SidebarToggleButton,
    CollapseTransition,
    BaseNav,
    Modal
  },
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    isRTL() {
      return this.$rtl.isRTL;
    }
  },
  data() {
    return {
      activeNotifications: false,
      showMenu: false,
      searchModalVisible: false,
      searchQuery: "",
      empName: ""
    };
  },

  mounted() {
    let jwtToken = JSON.parse(
      atob(sessionStorage.getItem("token").split(".")[1])
    );
    console.log(jwtToken);
    this.empName = jwtToken.empname;
    this.empid = jwtToken.employeeid;
  },

  methods: {
    logout() {
      this.$http
        .get(":9992/auth/staff/logout/" + this.empid)
        .then(res => {
          if (!res.error) {
            console.log(res.message);
            util.stopPing()
            sessionStorage.removeItem("token", res.message.jwt_token);
            this.$router.push("/login");
          } else {
          }
        })
        .catch(err => {
          console.log(err);
        });
      // let payload = {
      //   useremail: this.model.email,
      //   userpass: this.model.password
      // };

      // this.$http
      //   .post("https://alpha.vectolabs.com:8002/api/auth/login", payload)
      //   .then(res => {
      //     if (res.error) {
      //       //pupout oeror
      //       console.log(res.message);
      //       this.model.message= res.message;

      //     } else {
      //       //login OK!
      //       console.log(res.message.jwt_token);
      //       sessionStorage.setItem("token", res.message.jwt_token);
      //       this.$router.push("/dashboard");
      //     }
      //   })
      //   .catch(err => {
      //     console.log(err);
      //   });
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    }
  }
};
</script>
<style scoped>
.top-navbar {
  top: 0px;
}
hr {
  margin-top: 2%;
  margin-bottom: 0%;
}
.avatar-name {
  margin-top: 7%;
}
</style>
